import { createApiSlice } from 'app/createApiSlice'

export const cashFlowApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'catatan/arus-kas',
  endpoints(builder) {
    return {
      getArusKas: builder.query({
        query({ startdate, enddate, filter, page, size, categoryId }) {
          return {
            url: '/api/v2/bussines/cashflow',
            params: {
              size,
              startdate,
              page,
              enddate,
              subtype: filter,
              offlineCustomTypeID: categoryId,
              sortby: 'ts',
              sortdir: 'desc',
            },
          }
        },
      }),
      getCategoriesCashFlow: builder.query({
        query({ userId, type, active, allmanual = 0 }) {
          return {
            url: '/api/v1/bussines/cashflow/categories',
            params: {
              userId,
              type,
              active,
              allmanual
            },
          }
        },
      }),
      postCashFlow: builder.mutation({
        query(payload) {
          return {
            url: `/api/v2/bussines/cashflow`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      postCategorCashFlow: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/cashflow/customcategories`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      deleteCashFlow: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/cashflow/delete`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      getArusKasPersonal: builder.query({
        query({ startdate, enddate, filter, page, size, categoryId }) {
          return {
            url: '/api/v1/bussines/personal-cashflow',
            params: {
              size,
              startdate,
              page,
              enddate,
              subtype: filter,
              offlineCustomTypeID: categoryId,
              sortby: 'ts',
              sortdir: 'desc',
            },
          }
        },
      }),
      getCategoriesCashFlowPersonal: builder.query({
        query({ userId, type, active, allmanual = 0 }) {
          return {
            url: '/api/v1/bussines/personal-cashflow/categories',
            params: {
              userId,
              type,
              active,
              allmanual
            },
          }
        },
      }),
      postCashFlowPersonal: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/personal-cashflow`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      postCategorCashFlowPersonal: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/personal-cashflow/customcategories`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      deleteCashFlowPersonal: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/personal-cashflow/delete`,
            method: 'POST',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useGetArusKasQuery,
  useLazyGetArusKasQuery,
  usePostCashFlowMutation,
  usePostCategorCashFlowMutation,
  useDeleteCashFlowMutation,
  useGetCategoriesCashFlowQuery,
  useLazyGetCategoriesCashFlowQuery,
  useGetArusKasPersonalQuery,
  useLazyGetArusKasPersonalQuery,
  usePostCashFlowPersonalMutation,
  usePostCategorCashFlowPersonalMutation,
  useDeleteCashFlowPersonalMutation,
  useGetCategoriesCashFlowPersonalQuery,
  useLazyGetCategoriesCashFlowPersonalQuery,
} = cashFlowApiSlice
